export default __webpack_public_path__ + "static/5. Efficient Staff Management 2-6e882ad88a1b299f9b3794a6c3e1c0d6.jpg";